/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Own_Stock_TitleInputs */



/**
* | output |
* | --- |
* | "Your promo stock" |
*
* @param {Promo_Own_Stock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_own_stock_title = /** @type {((inputs?: Promo_Own_Stock_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Own_Stock_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre stock de promos")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su stock de promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu estoque de promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo stock di promo")
	return /** @type {LocalizedString} */ ("Your promo stock")
});